var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('more-button-dropdown',{scopedSlots:_vm._u([{key:"options-list",fn:function(){return [_c('ul',[_c('li',{on:{"click":function($event){return _vm.$emit('unlink-item-click')}}},[_c('span',[_vm._v(_vm._s(_vm.label))])])])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }